/* js/columns.js */


;(function($, window, document){

  /**
   * Set same height for all cols
   *
   * @param {string} strColSetSelector
   * @param {string} strColSelector
   */
  var setColHeight = function(strColSetSelector, strColSelector) {
    $(window).on("load resize",function(e){
      var objColSet = $(strColSetSelector);

      if(objColSet) {
        objColSet.each(function() {
          var objCols = $(this).find(strColSelector);

          // Reset height inline style
          objCols.height('auto');

          // Get cols max height
          var intHeight = Math.max.apply(Math, objCols.map(function(){return $(this).outerHeight();}).get());

          if(strColSelector == '.rs-column[class*="-large-col-5"]') {
            intHeight += objCols.find('.button').outerHeight();
          }

          // Set equal height for all cols
          objCols.height(intHeight);
        });
      }
    });
  }
  
    $(document).ready(function() {
        setColHeight('.layout_full .rs-columns', '.rs-column');
        setColHeight('.rs-columns', '.rs-column[class*="-large-col-5"]');
        if (typeof initCountdown !== 'undefined') {
            initCountdown();
        }
    });
    
})(jQuery, window, document);